



import Vue from "vue";
import Component from "vue-class-component";
import UserPromotion from "@/components/users/promotion/UserPromotion.vue";

@Component({
  components: { UserPromotion },
  metaInfo: {
    title: "Event Promotion – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Promote Arma 3 events to the Newfound Pioneer Corps community." },
      { vmid: "og:title", property: "og:title", content: "Event Promotion – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Promote Arma 3 events to the Newfound Pioneer Corps community." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/event-promotion" },
    ],
  },
})
export default class EventPromotion extends Vue {}
